module.exports = __webpack_public_path__ + "static/media/whats-new.13921c2d.md";